import { render, staticRenderFns } from "./rate-checker-table.view.vue?vue&type=template&id=0524b5c7&scoped=true&"
import script from "./rate-checker-table.view.vue?vue&type=script&lang=ts&"
export * from "./rate-checker-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./rate-checker-table.view.vue?vue&type=style&index=0&id=0524b5c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524b5c7",
  null
  
)

export default component.exports